import { uiText } from '../../i18n/uiText';
import React from 'react';
import { Disclosure } from '../common/WorkspaceSummary';
import AttachmentItem from '../common/AttachmentItem';
import '../../styles/audit-report.css';

function answerText(answer) {
  if (answer.value_bool != null) return answer.value_bool ? uiText("Да") : uiText("Нет");
  if (answer.value_number != null) return String(answer.value_number);
  return answer.value_text || uiText("Текстовый ответ не зафиксирован");
}

export default function RemovedAuditQuestions({ questions = [], answers = [], files = [] }) {
  if (!questions.length) return null;
  return <Disclosure title={uiText("Удалённые пункты · {v0}", {v0: (questions.length)})} hint={uiText("Архив только для администратора · не включается в новые отчёты")}>
    <div className="audit-removed-questions">
      <p className="audit-report-help">{uiText("Вопросы ниже исключены из действующего чек-листа. Сохранённые ответы и файлы доступны только для просмотра; связанные замечания и ПКПД продолжают отображаться в своих разделах.")}</p>
      {questions.map(question => {
        const match = item => question.extra_question_id
          ? Number(item.extra_question_id) === Number(question.extra_question_id)
          : item.question_id != null && Number(item.question_id) === Number(question.question_id);
        const retainedAnswers = answers.filter(match);
        const retainedFiles = files.filter(match);
        return <article className="audit-removed-question" key={question.frontend_key}>
          <div className="audit-removed-question-title"><strong>{question.text}</strong><span>{uiText("Удалён из чек-листа")}</span></div>
          <p className="audit-report-help">{question.section_title}{question.removed_at ? ` · ${new Date(question.removed_at).toLocaleString('ru-RU')}` : ''}</p>
          {question.reason ? <p className="audit-removed-question-copy"><strong>{uiText("Причина:")}</strong> {question.reason}</p> : null}
          {!retainedAnswers.length && !retainedFiles.length ? <p className="audit-report-help">{uiText("Сохранённых ответов и файлов не было.")}</p> : null}
          {retainedAnswers.map((answer, index) => <div className="audit-removed-answer" key={answer.id || index}>
            <small>{answer.answered_by === 'customer' ? uiText("Ответ проверяемого") : uiText("Ответ аудитора")}{answer.is_draft ? uiText(" · сохранённый черновик") : ''}</small>
            <p>{answerText(answer)}</p>
            {answer.comment_text ? <p><strong>{uiText("Свидетельства:")}</strong> {answer.comment_text}</p> : null}
          </div>)}
          {retainedFiles.map(file => <AttachmentItem key={file.id} file={file} />)}
        </article>;
      })}
    </div>
  </Disclosure>;
}
